/**
 * angular-ui-utils - Swiss-Army-Knife of AngularJS tools (with no external dependencies!)
 * @version v0.2.1 - 2015-01-02
 * @link http://angular-ui.github.com
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
app
  .directive('uiScrollfix', [
    '$window',
    function ($window) {
      'use strict';

      function getWindowScrollTop() {
        if (angular.isDefined($window.pageYOffset)) {
          return $window.pageYOffset;
        } else {
          var iebody =
            document.compatMode && document.compatMode !== 'BackCompat'
              ? document.documentElement
              : document.body;
          return iebody.scrollTop;
        }
      }
      return {
        require: '^?uiScrollfixTarget',
        link: function (scope, elm, attrs, uiScrollfixTarget) {
          var absolute = true,
            shift = 0,
            // HACK HERE
            // fixLimit,
            $target =
              (uiScrollfixTarget && uiScrollfixTarget.$element) ||
              angular.element($window);

          if (!attrs.uiScrollfix) {
            absolute = false;
          } else if (typeof attrs.uiScrollfix === 'string') {
            // charAt is generally faster than indexOf: http://jsperf.com/indexof-vs-charat
            if (attrs.uiScrollfix.charAt(0) === '-') {
              absolute = false;
              shift = -parseFloat(attrs.uiScrollfix.substr(1));
            } else if (attrs.uiScrollfix.charAt(0) === '+') {
              absolute = false;
              shift = parseFloat(attrs.uiScrollfix.substr(1));
            }
          }

          var containerElement, sizingElement;
          if (typeof attrs.uiScrollfixContainerElement === 'string') {
            containerElement = angular.element(
              attrs.uiScrollfixContainerElement,
            );
          }
          if (typeof attrs.uiScrollfixSizingElement === 'string') {
            sizingElement = angular.element(attrs.uiScrollfixSizingElement);
          }

          // HACK HERE: We don't actually need the fix limit here
          // fixLimit = absolute ? attrs.uiScrollfix : elm.offset().top + shift;
          function onScroll() {
            // HACK HERE: Take the element object instead of DomElement for the offset as DomElement doesn't update on dynamic content
            var limit = elm.offset().top + shift;
            var offset = uiScrollfixTarget
              ? $target.offset().top
              : getWindowScrollTop();

            // HACK HERE: Make it able to fixed within the container and extra handling on sizing element hit the bottom of the container
            if (containerElement && sizingElement) {
              var topBound = containerElement.offset().top + shift;
              var bottomBound =
                containerElement.offset().top +
                containerElement.height() -
                sizingElement.height() +
                shift;
              var isInsideContainer =
                offset >= topBound && offset < bottomBound;
              if (!elm.hasClass('ui-scrollfix') && isInsideContainer) {
                elm.addClass('ui-scrollfix');
              } else if (elm.hasClass('ui-scrollfix') && !isInsideContainer) {
                elm.removeClass('ui-scrollfix');
              }
              if (offset >= bottomBound) {
                elm.addClass('ui-scrollfix-sticky-bottom');
                // for doris_bien or other theme use original btn as fix btn to fade in-out
                if (
                  $('.js-sticky-cart-button-container').children() &&
                  $('.js-sticky-cart-button-container').children().length === 0
                ) {
                  elm.parent().addClass('opacity-in');
                }
                elm.parent().addClass('ui-scrollfix-sticky-mode');
              } else {
                elm.removeClass('ui-scrollfix-sticky-bottom');
                elm.parent().removeClass('ui-scrollfix-sticky-mode');
                // for doris_bien or other theme use original btn as fix btn to fade in-out
                if (
                  $('.js-sticky-cart-button-container').children() &&
                  $('.js-sticky-cart-button-container').children().length === 0
                ) {
                  elm.parent().removeClass('opacity-in');
                }
              }
            } else {
              // if pageYOffset is defined use it, otherwise use other crap for IE
              if (!elm.hasClass('ui-scrollfix') && offset > limit) {
                elm.addClass('ui-scrollfix');

                // HACK HERE:
                // fixLimit = limit;
              } else if (elm.hasClass('ui-scrollfix') && offset < limit) {
                // HACK HERE: Compare with limit directly instead of fixLimit
                elm.removeClass('ui-scrollfix');
              }
            }
          }

          $target.on('scroll', onScroll);

          // Unbind scroll event handler when directive is removed
          scope.$on('$destroy', function () {
            $target.off('scroll', onScroll);
          });
        },
      };
    },
  ])
  .directive('uiScrollfixTarget', [
    function () {
      'use strict';
      return {
        controller: [
          '$element',
          function ($element) {
            this.$element = $element;
          },
        ],
      };
    },
  ]);
